import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DisplayCarrierDepotComponent } from "./display-carrier-depot.component";
import { Routes, RouterModule } from "@angular/router";
import { CarrierDepotService } from "../service/carrier-depot.service";
import { PaginatorModule } from "primeng/paginator";
import { BusyModule } from "app/busy/busy.module";
import { NgxPaginationModule } from "ngx-pagination";
import { NgbModalModule } from "@ng-bootstrap/ng-bootstrap";
import { AuthWebService } from "app/services/authweb.service";
import { CarrierDepotDetailsModule } from "../carrier-depot-details/carrier-depot-details.module";

@NgModule({
  declarations: [DisplayCarrierDepotComponent],
  imports: [
    CommonModule,
    PaginatorModule,
    NgxPaginationModule,
    NgbModalModule,
    CarrierDepotDetailsModule,
  ],
  exports: [DisplayCarrierDepotComponent],
})
export class DisplayCarrierDepotModule {}
